import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { Button, Header, Modal } from 'semantic-ui-react';
import {
  closeUpdateRenewalStatusModal,
  updateEmployeeSlotIsRenewableStatus,
} from 'state/business/actions';

const UpdateRenewalStatusConfirmationModal = props => {
  const {
    updateRenewalStatusModal,
    selectedUpdateRenewalStatusIndex,
    purchasedEmployeeSlots,
    employeeLogsPage,
    allBusiness,
    dispatch,
  } = props;

  const handleOnCancelButtonClick = () => {
    dispatch(closeUpdateRenewalStatusModal());
  };

  const handleOnOKButtonClick = () => {
    const payload = {
      businessId: allBusiness.data[allBusiness.activeIndex].id,
      employeeLogsPage,
      slot_id: purchasedEmployeeSlots[selectedUpdateRenewalStatusIndex].id,
      is_renewable: !purchasedEmployeeSlots[selectedUpdateRenewalStatusIndex]
        .is_renewable,
      assigned_employee_id: purchasedEmployeeSlots[
        selectedUpdateRenewalStatusIndex
      ].employee
        ? purchasedEmployeeSlots[selectedUpdateRenewalStatusIndex].employee.id
        : null,
    };
    dispatch(updateEmployeeSlotIsRenewableStatus(payload));
    dispatch(closeUpdateRenewalStatusModal());
  };

  return (
    <Modal
      closeIcon
      size="tiny"
      open={updateRenewalStatusModal}
      onClose={handleOnCancelButtonClick}
    >
      {purchasedEmployeeSlots[selectedUpdateRenewalStatusIndex] ? (
        <>
          <Header
            icon={
              purchasedEmployeeSlots[selectedUpdateRenewalStatusIndex]
                .is_renewable
                ? 'dont'
                : 'sync alternate'
            }
            content={`${
              purchasedEmployeeSlots[selectedUpdateRenewalStatusIndex]
                .is_renewable
                ? 'Stop'
                : 'Activate'
            } Renewal Confirm`}
          />
          <Modal.Content>
            <p>
              Are you sure you want to{' '}
              {purchasedEmployeeSlots[selectedUpdateRenewalStatusIndex]
                .is_renewable
                ? 'stop'
                : 'activate'}{' '}
              renewal of slot ID{' '}
              {purchasedEmployeeSlots[selectedUpdateRenewalStatusIndex].id}?
            </p>
          </Modal.Content>
        </>
      ) : (
        <></>
      )}
      <Modal.Actions>
        <Button color="red" onClick={handleOnOKButtonClick}>
          OK
        </Button>
        <Button basic color="black" onClick={handleOnCancelButtonClick}>
          Cancel
        </Button>
      </Modal.Actions>
    </Modal>
  );
};

const mapStateToProps = ({ business }) => ({
  updateRenewalStatusModal: business.updateRenewalStatusModal,
  selectedUpdateRenewalStatusIndex: business.selectedUpdateRenewalStatusIndex,
  purchasedEmployeeSlots: business.purchasedEmployeeSlots,
  employeeLogsPage: business.employeeLogsPage,
  allBusiness: business.allBusiness,
});

UpdateRenewalStatusConfirmationModal.propTypes = {
  updateRenewalStatusModal: PropTypes.bool.isRequired,
  selectedUpdateRenewalStatusIndex: PropTypes.number.isRequired,
  employeeLogsPage: PropTypes.number.isRequired,
  purchasedEmployeeSlots: PropTypes.object.isRequired,
  allBusiness: PropTypes.object.isRequired,
  dispatch: PropTypes.func.isRequired,
};

export default connect(mapStateToProps)(UpdateRenewalStatusConfirmationModal);
